import React from "react";
import "./CSS/Loader.css";

const Loader = () => {
  return (
    <h1 className="h1">
      <span className="let1 span">l</span>
      <span className="let2 span">o</span>
      <span className="let3 span">a</span>
      <span className="let4 span">d</span>
      <span className="let5 span">i</span>
      <span className="let6 span">n</span>
      <span className="let7 span">g</span>
    </h1>
  );
};

export default Loader;
